/**
 * Marca local (por usuario, por navegador) de "tutorial ya mostrado". Respaldo para
 * cuando el PATCH /users/me/onboarding falla (red/500): evita que el tour se repita
 * en cada visita. Todo en try/catch — localStorage puede no estar disponible.
 */
const key = (phoneNumber: string) => `agrovid_tour_seen_${phoneNumber}`;

export function hasLocalTourSeen(phoneNumber: string | undefined): boolean {
  if (!phoneNumber) return false;
  try { return localStorage.getItem(key(phoneNumber)) === '1'; } catch { return false; }
}

export function markLocalTourSeen(phoneNumber: string | undefined): void {
  if (!phoneNumber) return;
  try { localStorage.setItem(key(phoneNumber), '1'); } catch { /* sin storage: se ignora */ }
}
